import { ref, reactive } from 'vue'

const state = reactive({
  writingDocumentation: {},
  writingQuestions: {
    current: null,
    unique: null,
    details: null,
    plans: null,
    quotes: null,
    other: null,
  },
  writing_tab: true,
})

const wordCount = ref(0)

const setState = ({ writingDocumentation, writingQuestions }) => {
  state.writingDocumentation.name = writingDocumentation
  state.writingQuestions = writingQuestions
}

const clearState = () => {
  state.writingDocumentation = {}
  state.writingQuestions = {
    current: null,
    unique: null,
    details: null,
    plans: null,
    quotes: null,
    other: null,
  }
}

export { state, wordCount, setState, clearState }
